import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { API } from '../../constants/api';
import './Verify.css';
import { ToastContainer, toast } from "react-toastify";

const Verify = () => {
  const { token } = useParams();
  console.log(token);
  const verifyUser = async () => {
    const response = await API.post('/api/verifyUser', {
      token
    });
    if (response.status === 201) {
        toast.success("Email Verification Success !!", {
        style: {
          fontSize: "18px",
          letterSpacing: "1px",
        },
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error("Invalid Token !!", {
        style: {
          fontSize: "18px",
          letterSpacing: "1px",
        },
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
  return (
    <>
      <Navbar />
      <ToastContainer theme="colored" />
      <div className='verify-container'>
        <button className='button-verify' onClick={verifyUser}>
          Verify
        </button>
      </div>
    </>
  );
}

export default Verify